import { NewestPacksByLabelPage } from '@bpm-web-app/components/pages';

const NewestPacksByLabel = () => <NewestPacksByLabelPage />;

export default NewestPacksByLabel;
